import { StylesConfig } from 'react-select';
import { components as rsComponents } from 'react-select';
import React from 'react';

/**
 * Custom Option that strips onMouseMove from innerProps.
 * react-select fires onMouseMove on every pixel of cursor movement,
 * triggering a focusedOption state update + re-render each time.
 * onMouseOver (fires once per option enter) is kept so react-select's
 * internal focus tracking, scrollbar handling, and keyboard navigation
 * continue to work correctly.
 */
const Option = (props: any) => {
    const { onMouseMove, ...rest } = props.innerProps;
    return React.createElement(rsComponents.Option, {
        ...props,
        innerProps: rest,
    });
};

export const reactSelectComponents = { Option };

/**
 * Shared react-select styles aligned with the TextField component.
 * Matches border, border-radius, padding, height, focus ring, and font sizing.
 */
export const reactSelectStyles: StylesConfig = {
    control: (base, state) => ({
        ...base,
        border: '1px solid #e6e6e6',
        borderRadius: '0.5rem',
        backgroundColor: state.isDisabled ? '#f8f9fa' : '#fff',
        boxShadow: state.isFocused ? '0 0 0 3px rgba(13, 110, 253, 0.15)' : 'none',
        borderColor: state.isFocused ? '#0d6efd' : '#e6e6e6',
        fontSize: '0.95rem',
        minHeight: '38px',
        outline: 'none',
        transition: 'border-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
        '&:hover': {
            borderColor: state.isFocused ? '#0d6efd' : '#ccc',
        },
    }),
    valueContainer: (base) => ({
        ...base,
        padding: '0 0.75rem',
        height: '36px',
        display: 'flex',
        alignItems: 'center',
    }),
    input: (base) => ({
        ...base,
        color: '#212529',
        margin: 0,
        padding: 0,
    }),
    singleValue: (base) => ({
        ...base,
        color: '#212529',
        fontWeight: 400,
        margin: 0,
    }),
    placeholder: (base) => ({
        ...base,
        color: '#adb5bd',
        fontWeight: 400,
        margin: 0,
    }),
    indicatorSeparator: () => ({
        display: 'none',
    }),
    dropdownIndicator: (base, state) => ({
        ...base,
        padding: '0 0.5rem',
        color: state.isFocused ? '#0d6efd' : '#adb5bd',
        '&:hover': {
            color: '#0d6efd',
        },
    }),
    clearIndicator: (base) => ({
        ...base,
        padding: '0 0.25rem',
    }),
    menu: (base) => ({
        ...base,
        borderRadius: '0.5rem',
        boxShadow: '0 4px 16px rgba(0, 0, 0, 0.12)',
        border: '1px solid #e6e6e6',
        overflow: 'hidden',
        zIndex: 20,
    }),
    menuList: (base) => ({
        ...base,
        padding: '4px 0',
    }),
    option: (base, state) => ({
        ...base,
        fontSize: '0.95rem',
        backgroundColor: state.isSelected ? '#0d6efd' : state.isFocused ? '#f0f4ff' : 'transparent',
        color: state.isSelected ? '#fff' : '#212529',
        cursor: 'pointer',
        transition: 'none',
        '&:active': {
            backgroundColor: '#0d6efd',
            color: '#fff',
        },
    }),
};
